import { Button, Result } from "antd";
import { ToolOutlined } from "@ant-design/icons";

import "../../styles/pages/maintenance/maintenanceGate.scss";

const MaintenanceGate = () => {
  return (
    <div className="maintenance-gate">
      <Result
        icon={<ToolOutlined />}
        title="PIVOT is under maintenance"
        subTitle={
          <>
            Oops — looks like you've caught us in the middle of something! We're
            upgrading and fixing PIVOT behind the scenes. Please check back a
            little later.
            <br />
            Thank you for your patience!
          </>
        }
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            Try Again
          </Button>
        }
      />
    </div>
  );
};

export default MaintenanceGate;
